export const FETCH_EDITABLE_LOCAL_ADMIN_INFO = 'FETCH_EDITABLE_LOCAL_ADMIN_INFO'
export const FETCH_EDITABLE_LOCAL_ADMIN_INFO_SUCCESS = 'FETCH_EDITABLE_LOCAL_ADMIN_INFO_SUCCESS'
export const FETCH_EDITABLE_LOCAL_ADMIN_ERROR = 'FETCH_EDITABLE_LOCAL_ADMIN_ERROR'
export const SAVE_EDITABLE_LOCAL_ADMIN = 'SAVE_EDITABLE_LOCAL_ADMIN'
export const CLEAR_EDITABLE_LOCAL_ADMIN = 'CLEAR_EDITABLE_LOCAL_ADMIN'
export const SET_EDITABLE_LOCAL_ADMIN_INFO = 'SET_EDITABLE_LOCAL_ADMIN_INFO'
